import React, {useState, useEffect} from 'react'
import Tooltip from '../Shared/Tooltip'
import TileView from '../Shared/TileView'
import ListView from '../Shared/ListView'
import { withUserStore } from '../../contexts/UserStore'
import { withModals } from '../../contexts/modals'

const PageView = ({ modalActions, pageProvider, userStore }) => {
  // pageProvider: recordType: method
  //               pageHeader: method
  //               filterFields: method (optional)
  //               filterRecords: method (optional)
  //               renderRecord: method (optional)
  //               click: method (optional)
  //               clickUrl: method (optional)
  //               formName: method
  //               newRecord: method
  //               journalThreadPageProvider: method
  //               commentThreadPageProvider: method

  //               destroy: method
  //               showJournal: boolean
  //               showComment: boolean

  const [records, setRecords] = useState([])
  const [mode, setMode] = useState('Tile')
  const [canCreateState, setCanCreateState] = useState(false)

  const modeSettingName = () => pageProvider.recordType() + '-PageView-mode'

  useEffect(() => {
    setMode(userStore.getAccountsUserSetting(modeSettingName()) || 'Tile')
  }, [])

  useEffect(() => {
    // Types that require currentAccountsUser context before loading
    const requiresAccountsUser = ['goals', 'tasks']
    const recordType = pageProvider.recordType()
    
    // Skip loading if this type requires currentAccountsUser but it's not set yet
    if (requiresAccountsUser.includes(recordType) && !userStore.currentAccountsUser) {
      return
    }
    
    if (pageProvider.records) {
      // Use custom records function if provided
      const customRecords = pageProvider.records()
      setRecords(customRecords)
    } else {
      // Fall back to standard getRecords
      userStore.getRecords(pageProvider.recordType(), null, null, (r) => setRecords(r))
    }
  }, [userStore.account?.[pageProvider.recordType()], userStore.account?.invitations, userStore.currentAccountsUser])

  // Monitor currentAccountsUser changes to update create permissions
  useEffect(() => {
    const recordType = pageProvider.recordType()
    const canCreateValue = userStore.canCreate(recordType)
    setCanCreateState(Boolean(canCreateValue))
  }, [userStore.currentAccountsUser, pageProvider.recordType()])

  const updateMode = (mode) => {
    userStore.setAccountsUserSetting(modeSettingName(), mode)
    setMode(mode)
  }

  const renderChild = (record) => {
    if (pageProvider.renderRecord) { return pageProvider.renderRecord(record, mode) } else { return record.name }
  }

  const entries = () => {
    let list = records || []
    if (pageProvider.filterRecords) { list = list.filter(pageProvider.filterRecords) }
    return list.map((r) => {
      return {
        record: r,
        pageProvider: pageProvider,
        el: renderChild(r),
        click: (pageProvider.click && ((r) => pageProvider.click(r))),
        clickUrl: (pageProvider.clickUrl && pageProvider.clickUrl(r)),
        editModal: {
          name: 'ModalForm',
          formName: userStore.lex.edit + ' ' + pageProvider.formName(r) + '...',
          formRecord: r,
          formSource: pageProvider
        },
        journalModal: {
          disableFormButtons: true,
          name: 'ModalForm',
          formName: userStore.lex.journal + ' ' + pageProvider.formName(r) + '...',
          formRecord: r,
          formSource: pageProvider.journalThreadPageProvider
        },
        commentModal: {
          disableFormButtons: true,
          name: 'ModalForm',
          formName: userStore.lex.comments + ' for ' + pageProvider.formName(r) + '...',
          formRecord: r,
          formSource: pageProvider.commentThreadPageProvider
        }
      }
    })
  }

  return (
    <div>
      <div className="full-width">
        <div className="float-left">{pageProvider.pageHeader()}</div>
        {pageProvider.filterFields && <div className="center"> {pageProvider.filterFields()} </div>}
        <div className="float-right">
          {canCreateState &&
              <>
                <div
                  className="margin-left-10 button"
                  id="add-button"
                  data-cy="add-button"
                  onClick={() => modalActions.openModal({
                    name: 'ModalForm',
                    formName: userStore.lex.new + ' ' + pageProvider.formName({}) + '...',
                    formRecord: pageProvider.newRecord(),
                    formSource: pageProvider
                  })}
                ><i className="fas fa-plus" />
                </div>
                <Tooltip delay={250} target="add-button">
                  Add {pageProvider.formName()}...
                </Tooltip>
              </>}
          {(mode !== 'Tile') &&
            <>
              <div className="margin-left-10 button" id="view-button" onClick={() => updateMode('Tile')}><i className="fas fa-grid" /></div>
              <Tooltip delay={250} target="view-button">
                Tile View...
              </Tooltip>
            </>}
          {(mode !== 'List') &&
            <>
              <div className="margin-left-10 button" id="view-button" onClick={() => updateMode('List')}><i className="fas fa-list" /></div>
              <Tooltip delay={250} target="view-button">
                List View...
              </Tooltip>
            </>}
        </div>
      </div>
      {(mode === 'List') && <ListView recordType={pageProvider.recordType()} entries={entries()} /> }
      {(mode === 'Tile') && <TileView recordType={pageProvider.recordType()} entries={entries()} /> }
    </div>
  )
}

export default withUserStore(withModals(PageView))
